/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { Link } from 'react-router-dom';
// reactstrap components
import { Navbar, Container, Button } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../Redux/actions/authAction';
const AdminNavbar = props => {
	const dispatch = useDispatch();
	return (
		<>
			<Navbar
				className='navbar-top navbar-dark'
				expand='md'
				id='navbar-main'
			>
				<Container fluid>
					<Link
						className='h4 mb-0 text-white text-uppercase d-none d-lg-inline-block'
						to='/'
					>
						{props.brandText}
					</Link>
					{/* <Link to='/auth/login'> */}{' '}
					<Button
						className='d-none d-md-block'
						onClick={() => {
							dispatch(logout());
						}}
					>
						{' '}
						Log Out
					</Button>
					{/* </Link> */}
				</Container>
			</Navbar>
		</>
	);
};

export default AdminNavbar;
